import { Icon } from '@chakra-ui/react';

import {
  FaMagnet,
  FaChartSimple,
  FaWrench,
  FaGear,
  FaHouseChimney,
  FaUser,
  FaStore,
  FaListCheck,
  FaInbox,
} from 'react-icons/fa6';

import ValidatedPoliciesView from 'views/validated_policies';
import DocumentsHubView from 'views/documents_hub';
import PolicyOverviewView from 'views/policy_overview';
import UserList from 'views/user_list';
import HomepageBannersView from 'views/homepage_banners/HomepageBannersView';
import BadgesView from 'views/badges/BadgesView';
import QuickLinksView from 'views/settings/QuickLinksView';
import MvrCarrierRulesView from 'views/mvr_carrier_rules/MvrCarrierRulesView';
import LeadsView from 'views/leads';
import LeadOverviewView from 'views/lead_overview';
import LeadFormView from 'views/new_edit_lead';
import UserFormView from 'views/new_edit_user';
import WorkflowListView from 'views/workflow_list';
import WorkflowFormView from 'views/new_edit_workflow';
import BranchListView from 'views/branch_list';
import BranchFormView from 'views/new_edit_branch';
import TagListView from 'views/tag_list';
import TagFormView from 'views/new_edit_tag';
import ComingSoon from 'views/coming_soon';
import Home from 'views/home';
import AnalyticsView from 'views/analytics/AnalyticsView';
import WorkInProgressView from 'views/work_in_progress/WorkInProgressView';
import AllLeadsList from 'views/leads/components/AllLeadsList';
import CallListView from 'views/call_list';
import CarrierListView from 'views/carrier_list';
import CarrierFormView from 'views/new_edit_carrier';
import SubmissionOverviewView from 'views/submission_overview';
import ProducerCodeListView from 'views/producer_code_list';
import ProducerCodeFormView from 'views/new_edit_producer_code';
import DashReportView from 'views/dash_report';
import MvrRequestView from 'views/mvr_request';
import BinderReportView from 'views/binder_report/BinderReportView';
import BillingOverview from 'views/billing_overview';
import CustomersListView from 'views/customers';
import CustomerOverviewView from 'views/customers/CustomerOverviewView';
import ClientCenterListView from 'views/client_center';
import ClientCenterView from 'views/client_center/ClientCenterView';
import { NotificationsManagementView } from 'views/notifications/NotificationsManagementView';
import { MyNotificationsView } from 'views/notifications/MyNotificationsView';
import QuoteMarketplaceView from 'views/quote_marketplace';
import ActurisCustomerView from 'views/quote_marketplace/ActurisCustomerView';
import OpenedQuoteView from 'views/quote_marketplace/OpenedQuoteView';
import InvoicingBillingView from 'views/quote_marketplace/InvoicingBillingView';
import RFQQuoteView from 'views/quote_marketplace/RFQQuoteView';

import {
  ROLE_ADMIN,
  ROLE_MANAGER,
  ROLE_BROKER_PARTNER,
  ROLE_BROKER,
  ROLE_ACCOUNT_MANAGER,
  ROLE_ACCOUNT_ASSISTANT,
} from 'variables/constants';

// BARA views — imported lazily to avoid bundle impact when FF is off
import ReferralQueueView from 'views/bara/ReferralQueueView';
import BranchSettingsView from 'views/bara/BranchSettingsView';
import BaraBranchSettingsListView from 'views/bara/BaraBranchSettingsListView';
import BaraReferralReportView from 'views/bara/BaraReferralReportView';
import BaraPostBindReviewView from 'views/bara/BaraPostBindReviewView';

const routes = [
  {
    name: 'Home',
    layout: '/admin',
    path: '/home',
    icon: <Icon as={FaHouseChimney} color="inherit" />,
    component: <Home />,
  },
  {
    name: 'My Notifications',
    layout: '/admin',
    path: '/notifications',
    component: <MyNotificationsView />,
    show: false,
  },
  {
    name: 'Analytics',
    layout: '/admin',
    path: '/analytics',
    icon: <Icon as={FaChartSimple} color="inherit" />,
    component: <AnalyticsView />,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Customers',
    path: '/customers',
    icon: <Icon as={FaUser} color="inherit" />,
    collapse: true,
    is_open: true,
    permissions: [ROLE_ADMIN, ROLE_MANAGER, ROLE_BROKER_PARTNER, ROLE_BROKER],
    items: [
      {
        name: 'Customers',
        layout: '/admin',
        path: '/customers/list',
        component: <CustomersListView />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Customers',
        layout: '/admin',
        path: '/customers/acturis',
        component: <ClientCenterListView />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Client Center',
        layout: '/admin',
        path: '/customers/acturis/:id',
        component: <ClientCenterView />,
        show: false,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Customer Overview',
        layout: '/admin',
        path: '/customers/:id',
        component: <CustomerOverviewView />,
        show: false,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Policies',
        layout: '/admin',
        path: '/customers/customer-policies',
        component: <ComingSoon />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
    ],
  },
  {
    name: 'Quote Marketplace',
    layout: '/admin',
    path: '/quote-marketplace',
    icon: <Icon as={FaStore} color="inherit" />,
    component: <QuoteMarketplaceView />,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_ASSISTANT,
      ROLE_ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Client Overview',
    parent: 'Quote Marketplace',
    layout: '/admin',
    path: '/quote-marketplace/customer/:contactRef',
    component: <ActurisCustomerView />,
    show: false,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_ASSISTANT,
      ROLE_ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Billing Information',
    parent: 'Client Overview',
    layout: '/admin',
    path: '/quote-marketplace/customer/:contactRef/billing/:rfqRef/:quoteRef',
    component: <InvoicingBillingView />,
    show: false,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_ASSISTANT,
      ROLE_ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Policy Information',
    parent: 'Client Overview',
    layout: '/admin',
    path: '/quote-marketplace/customer/:contactRef/rfq/:quoteId',
    component: <RFQQuoteView />,
    show: false,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_ASSISTANT,
      ROLE_ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Opened Quote',
    parent: 'Client Overview',
    layout: '/admin',
    path: '/quote-marketplace/customer/:contactRef/:lob/:quoteId/:step',
    component: <OpenedQuoteView />,
    show: false,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_ASSISTANT,
      ROLE_ACCOUNT_MANAGER,
    ],
  },
  {
    name: 'Lead Management',
    path: '/leads',
    icon: <Icon as={FaMagnet} color="inherit" />,
    permissions: [
      ROLE_ADMIN,
      ROLE_MANAGER,
      ROLE_BROKER_PARTNER,
      ROLE_BROKER,
      ROLE_ACCOUNT_MANAGER,
      ROLE_ACCOUNT_ASSISTANT,
    ],
    collapse: true,
    is_open: true,
    items: [
      {
        name: 'My Leads',
        layout: '/admin',
        path: '/leads/list',
        component: <LeadsView />,
      },
      {
        name: 'Call List',
        layout: '/admin',
        path: '/leads/calls',
        component: <CallListView />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Search Leads',
        layout: '/admin',
        path: '/leads/search',
        component: <AllLeadsList />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Lead Overview',
        layout: '/admin',
        path: '/leads/:id',
        component: <LeadOverviewView />,
        show: false,
      },
      {
        name: 'Create New Lead',
        layout: '/admin',
        path: '/leads/create',
        component: <LeadFormView />,
        show: false,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
      {
        name: 'Edit Lead',
        layout: '/admin',
        path: '/leads/edit/:id',
        component: <LeadFormView />,
        show: false,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
    ],
  },
  {
    name: 'Policy Management',
    path: '/policies',
    icon: <Icon as={FaListCheck} color="inherit" />,
    collapse: true,
    items: [
      {
        name: 'Binders',
        layout: '/admin',
        path: '/policies/list',
        component: <ValidatedPoliciesView />,
      },
      {
        name: 'Work in Progress',
        layout: '/admin',
        path: '/policies/work-in-progress',
        component: <WorkInProgressView />,
      },
      {
        name: 'Documents',
        layout: '/admin',
        path: '/policies/documents',
        component: <DocumentsHubView />,
      },
      {
        name: 'Submissions',
        layout: '/admin',
        path: '/policies/submission/:id',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Submissions',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Submissions',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid/validations',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Submissions',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid/specialty',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Legacy Auto Submission',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid/legacy-auto',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Submissions',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid/life',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Submissions',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid/personal',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Commercial Submission',
        layout: '/admin',
        path: '/policies/submission/:id/:uuid/commercial',
        component: <SubmissionOverviewView />,
        show: false,
      },
      {
        name: 'Policy Overview',
        layout: '/admin',
        path: '/policies/overview/:uuid',
        component: <PolicyOverviewView />,
        show: false,
      },
      {
        name: 'Binder Report',
        layout: '/admin',
        path: '/policies/report/:uuid',
        component: <BinderReportView />,
        show: false,
      },
      {
        name: 'Billing Overview',
        layout: '/admin',
        path: '/policies/payments/:uuid',
        component: <BillingOverview />,
        show: false,
      },
      {
        name: 'Tasks',
        layout: '/admin',
        path: '/policies/tasks',
        component: <ComingSoon />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_ASSISTANT,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
      {
        name: 'Cancellations',
        layout: '/admin',
        path: '/policies/cancellations',
        component: <ComingSoon />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_ASSISTANT,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
      {
        name: 'Renewals',
        layout: '/admin',
        path: '/policies/renewals',
        component: <ComingSoon />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_ASSISTANT,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
      {
        name: 'Claims',
        layout: '/admin',
        path: '/policies/claims',
        component: <ComingSoon />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_ASSISTANT,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
      {
        name: 'Billing',
        layout: '/admin',
        path: '/policies/billing',
        component: <ComingSoon />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
          ROLE_ACCOUNT_ASSISTANT,
          ROLE_ACCOUNT_MANAGER,
        ],
      },
    ],
  },
  {
    name: 'Tools',
    path: '/tools',
    icon: <Icon as={FaWrench} width="20px" height="20px" color="inherit" />,
    permissions: [ROLE_ADMIN, ROLE_MANAGER, ROLE_BROKER_PARTNER, ROLE_BROKER],
    collapse: true,
    items: [
      {
        name: 'DASH Report',
        layout: '/admin',
        path: '/tools/dash-report',
        component: <DashReportView />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Referral Report',
        layout: '/admin',
        path: '/tools/bara/report',
        component: <BaraReferralReportView />,
        featureFlag: 'enable-bara',
        permissions: [ROLE_ADMIN, ROLE_MANAGER],
      },
      {
        name: 'MVR Request',
        layout: '/admin',
        path: '/tools/mvr-request',
        component: <MvrRequestView />,
        featureFlag: 'enable-mvr-request',
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
    ],
  },
  {
    name: 'Settings',
    path: '/settings',
    icon: <Icon as={FaGear} width="20px" height="20px" color="inherit" />,
    permissions: [ROLE_ADMIN, ROLE_MANAGER, ROLE_BROKER_PARTNER, ROLE_BROKER],
    collapse: true,
    items: [
      {
        name: 'Users',
        layout: '/admin',
        path: '/settings/users',
        component: <UserList />,
        permissions: [ROLE_ADMIN, ROLE_MANAGER],
      },
      {
        name: 'Homepage Banners',
        layout: '/admin',
        path: '/settings/homepage-banners',
        component: <HomepageBannersView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Badges',
        layout: '/admin',
        path: '/settings/badges',
        component: <BadgesView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Quick Links',
        layout: '/admin',
        path: '/settings/quick-links',
        component: <QuickLinksView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'MVR Carrier Rules',
        layout: '/admin',
        path: '/settings/mvr-carrier-rules',
        component: <MvrCarrierRulesView />,
        featureFlag: 'enable-mvr-request',
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'New user',
        layout: '/admin',
        path: '/settings/users/new',
        component: <UserFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Edit user',
        layout: '/admin',
        path: '/settings/users/edit/:id',
        component: <UserFormView />,
        show: false,
        permissions: [ROLE_ADMIN, ROLE_MANAGER],
      },
      {
        name: 'Workflows',
        layout: '/admin',
        path: '/settings/workflows',
        component: <WorkflowListView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'New workflow',
        layout: '/admin',
        path: '/settings/workflows/new',
        component: <WorkflowFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Edit workflow',
        layout: '/admin',
        path: '/settings/workflows/edit/:id',
        component: <WorkflowFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Branches',
        layout: '/admin',
        path: '/settings/branches',
        component: <BranchListView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'New branch',
        layout: '/admin',
        path: '/settings/branches/new',
        component: <BranchFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Edit branch',
        layout: '/admin',
        path: '/settings/branches/edit/:id',
        component: <BranchFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Lead Tags',
        layout: '/admin',
        path: '/settings/tags',
        component: <TagListView />,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'New tag',
        layout: '/admin',
        path: '/settings/tags/new',
        component: <TagFormView />,
        show: false,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Edit tag',
        layout: '/admin',
        path: '/settings/tags/edit/:id',
        component: <TagFormView />,
        show: false,
        permissions: [
          ROLE_ADMIN,
          ROLE_MANAGER,
          ROLE_BROKER_PARTNER,
          ROLE_BROKER,
        ],
      },
      {
        name: 'Carriers',
        layout: '/admin',
        path: '/settings/carriers',
        component: <CarrierListView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'New Carrier',
        layout: '/admin',
        path: '/settings/carriers/new',
        component: <CarrierFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Edit Carrier',
        layout: '/admin',
        path: '/settings/carriers/edit/:id',
        component: <CarrierFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Producer Codes',
        layout: '/admin',
        path: '/settings/producer_codes',
        component: <ProducerCodeListView />,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'New Producer Code',
        layout: '/admin',
        path: '/settings/producer_codes/new',
        component: <ProducerCodeFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Edit Producer Code',
        layout: '/admin',
        path: '/settings/producer_codes/edit/:id',
        component: <ProducerCodeFormView />,
        show: false,
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'Notifications',
        layout: '/admin',
        path: '/settings/notifications',
        component: <NotificationsManagementView />,
        featureFlag: 'enable-big-communications',
        permissions: [ROLE_ADMIN],
      },
      {
        name: 'After-Hours Referral Branch Settings',
        layout: '/admin',
        path: '/settings/bara/branch-settings',
        component: <BaraBranchSettingsListView />,
        featureFlag: 'enable-bara',
        permissions: [ROLE_ADMIN, ROLE_MANAGER],
      },
    ],
  },
  // ── BARA routes — sidebar visibility controlled in Links.tsx via FF + capabilities ──
  {
    name: 'Referral Queue',
    layout: '/admin',
    path: '/bara/referral-queue',
    icon: <Icon as={FaInbox} color="inherit" />,
    component: <ReferralQueueView />,
  },
  {
    // Accessed via deep-link from BARA QR Jira ticket — no sidebar entry
    name: 'After-Hours Referral Post-Bind Review',
    layout: '/admin',
    path: '/bara/post-bind-review/:referralId',
    component: <BaraPostBindReviewView />,
    show: false,
  },
  {
    // Detail view — navigated to from the list above
    name: 'Branch After-Hours Referral Settings',
    layout: '/admin',
    path: '/settings/bara/branch-settings/:branchId',
    component: <BranchSettingsView />,
    show: false,
    permissions: [ROLE_ADMIN, ROLE_MANAGER],
  },
];

export default routes;
